<!-- 配货审批 -->
<template>
  <div class="backgroundGrey">
    <div v-if="appList.length">
      <div class="details-card" v-for="(item,index) in appList" :key="index">
        <div class="details-title">
          {{ item.applyNo }}
          <span style="float:right;">{{ $utils.subAppStatus(item.applyStatus) }}</span>
        </div>
        <div class="detailsItem" @click="openDetails(item)">
          <div>
            <span>航班日期：</span>
            <span>{{ item.flightDate }}</span>
          </div>
          <div>
            <span>航线环：</span>
            <span>{{ item.flightNoRing }}</span>
          </div>
          <div>
            <span>航段环：</span>
            <span>{{ item.flightLineRing }}</span>
          </div>
          <div>
            <span>申请数量：</span>
            <span>{{ item.quantity }}</span>
          </div>
          <div>
            <span>可供数量：</span>
            <span>{{ item.realQuantity }}</span>
          </div>
        </div>
      </div>
    </div>

    <EmptyTips :tipsList="['暂无审批']" v-else />
  </div>
</template>

<script>
import EmptyTips from '@/components/common/EmptyTips'

export default {
  components: {
    EmptyTips,
  },
  data() {
    return {
      main: {},
      appList: [],
    }
  },
  activated() {
    this.appList = []
    this.getAddMatterApplyList()
  },
  methods: {
    openDetails(item) {
      this.$utils.routerPush({
        name: 'DistributionApprovalDetails',
        query: {
          flightDate: item.flightDate,
          flightNoRing: item.flightNoRing,
          flightLineRing: item.flightLineRing,
          id: item.id,
        },
      })
    },
    // 机组获取加配单据列表
    getAddMatterApplyList() {
      let url = '/api-sys/sell/addMatterSearch/getApprove'
      let params = {
        staffId: this.$store.state.userInfo.userId,
        companyId: this.$store.state.userInfo.companyId,
        pageNum: 1,
        pageSize: 10000,
      }
      this.$api.post(url, params).then((res) => {
        this.appList = res.data.list
      })
    },
  },
}
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/view/DistributionApproval/DistributionApproval.vue